import { Button, DialogTrigger } from '@/_components/ui'
import { formatCurrency } from '@/_helpers/currency'
import { type TSimulateApplicationOutputDTO } from '@doutorsim/shared/applications'

export type Installment = TSimulateApplicationOutputDTO

interface InstallmentItemProps {
  installment: Installment
  selected?: boolean
  onClick: (installment: Installment) => void
  disabled?: boolean
  isInterestRateVisible?: boolean
}

export const InstallmentDropItem = ({
  installment,
  selected,
  onClick,
  disabled,
}: InstallmentItemProps) => {
  if (!installment) return

  const { numPayments, monthlyPaymentAmount } = installment
  const selectedBorderStyle = selected
    ? 'border-2 border-brand-green-primary-5'
    : 'border border-brand-grayscale-1'
  const disabledStyle = disabled ? 'opacity-50' : ''

  return (
    <button
      onClick={() => onClick(installment)}
      disabled={disabled}
      className={`flex h-12 w-full flex-row items-center justify-between rounded-lg px-2 py-[30px] hover:bg-brand-grayscale-2 ${selectedBorderStyle} ${disabledStyle}`}
      type="button"
    >
      <div className="items-left flex text-left">
        <div className="flex flex-col">
          <span className="text-[14px] font-bold text-brand-grayscale-12">
            {numPayments}x {formatCurrency(monthlyPaymentAmount)}
          </span>
          <span className="text-[10px] font-semibold text-brand-grayscale-7">
            Total de {formatCurrency(numPayments * monthlyPaymentAmount)}
          </span>
        </div>
      </div>
      <DialogTrigger asChild>
        <Button variant="primary" className="ml-6 h-fit w-fit p-0 text-[12px] font-bold">
          Ver detalhes
        </Button>
      </DialogTrigger>
    </button>
  )
}
